import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags" // Added Meta Tag npm Package
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardText,
  Table,
  UncontrolledTooltip,
  Container,
  Button,
  Alert,
  Modal,
} from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import { Link, useHistory } from "react-router-dom"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"

import axios from "axios"
import {
  HRConfig,
  TOAST_OPTIONS,
  formatDate,
  downloadBase64File,
  getContentTypeFromBase64,
} from "../../helpers/backend_helper"
import * as url from "helpers/url_helper"
import { useParams } from "react-router-dom"

import toastr from "toastr"
import "toastr/build/toastr.min.css"
import Select from "react-select"
import Swal from "sweetalert2"
import { Autosave, useAutosave } from "react-autosave"

import LoadingOverlay from "react-loading-overlay"
import ClimbingBoxLoader from "react-spinners/ClimbingBoxLoader"

const PurchaseRequisitionDetails = () => {
  const history = useHistory()
  const { id } = useParams()
  const [state, setState] = useState({})

  const [rows1, setrows1] = useState([{ id: 1 }])
  const [formRows, setFormRows] = useState([{ id: 1 }])

  const onAddFormRow = () => {
    const modifiedRows = [...formRows]
    modifiedRows.push({ id: modifiedRows.length + 1 })
    setFormRows(modifiedRows)
  }

  const onDeleteFormRow = id => {
    if (id !== 1) {
      var modifiedRows = [...formRows]
      modifiedRows = modifiedRows.filter(x => x["id"] !== id)
      setFormRows(modifiedRows)
    }
  }

  const [inputs, setInputs] = useState([])
  const [empNo, setEmpNo] = useState("")
  const [empName, setEmpName] = useState("")
  const [empTitle, setEmpTitle] = useState("")
  const [departmentcode, setDepartmentCode] = useState("")
  const [currencies, setCurrencies] = useState([])
  const [locations, setLocations] = useState([])
  const [workplans, setWorkPlans] = useState([])
  const [gLAccounts, setGLAccounts] = useState([])
  const [wkPlanGLAccounts, setWorkPlanGLAccounts] = useState([])
  const [items, setItems] = useState([])
  const [fixedAssets, setFixedAssets] = useState([])
  const [workPlanEntry, setWorkPlanEntry] = useState([])
  const [unitOfMeasure, setUnitOfMeasure] = useState([])
  const [vendors, setVendors] = useState([])

  const [rNo, setRNo] = useState("")
  const [form, setForm] = useState("")
  const [subject, setSubject] = useState("")
  const [postingDate, setPostingDate] = useState("")
  const [suppliesWorksServices, setSuppliesWorksServices] = useState("")
  const [budgetName, setBudgetName] = useState("")
  const [currencyCode, setCurrencyCode] = useState("")
  const [locationCode1, setLocationCode1] = useState("")
  const [RStatus, setRStatus] = useState("")
  const [workplanno, setWorkPlanNo] = useState("")
  const [procumentPlanReference, setProcurementPlanReference] = useState("")
  const [expectedreceiptdate, setExpectedReceiptDate] = useState("")
  const [expecteddeliverydate, setExpectedDeliveryDate] = useState("")
  const [validtodate, setValidtoDate] = useState("")

  const [selectedType, setSelectedType] = useState("")
  const [lineSystemID, setLineSystemId] = useState("")
  const [lineNo, setLineNo] = useState("")
  const [selectedNo, setSelectedNo] = useState("")
  const [description2, setDescription2] = useState("")
  const [quantity, setQuantity] = useState(0)
  const [workPlanEntryNo, setWorkPlanEntryNo] = useState("")
  const [glcontrolacc, setGLControlAccount] = useState("")
  const [selectedUnitOfMeasure, setSelectedUnitOfMeasure] = useState("")
  const [directUnitCost, setDirectUnitCost] = useState(0)

  const [purchaseRequisitionLines, setPurchaseRequisitionLines] = useState([])
  const [CompanyID, setCompanyID] = useState("")

  const [noo, setNoo] = useState([])
  const [approvalCommentLines, setApprovalCommentLines] = useState([])

  const [isloading, setIsloading] = useState(false)
  const [userError, setUserError] = useState(true)
  const [ipaSaved, setIpaSaved] = useState(false)
  const [modal_comments, setmodal_comments] = useState(false)

  const [modal_item, setmodal_item] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [modal_PlanningSpecifications, setmodal_PlanningSpecifications] =
    useState(false)

  const [addDetails, setAddDetails] = useState(false)
  const [editLine, setEditLine] = useState(false)
  const [managementActivities, setManagementActivities] = useState([])

  const [loadingFiles, setLoadingFiles] = useState(false)
  const [selectedFile, setSelectedFile] = useState([])
  const [uploadedFiles, setUploadedFiles] = useState([])
  const [modal_attachments, setmodal_attachments] = useState(false)

  const [specification, setSpecification] = useState("")
  const [plannedDate, setPlannedDate] = useState("")
  const [category, setCategory] = useState("")
  const [procurementtype, setProcurementType] = useState("")
  const [procurementmethod, setProcurementMethod] = useState("")
  const [uom, setUOM] = useState("")
  const [specificationid, setSpecificationID] = useState("")

  const removeBodyCss = () => {
    document.body.classList.add("no_padding")
  }

  const tog_comments = () => {
    setmodal_comments(!modal_comments)
    removeBodyCss()
  }

  const tog_item = () => {
    setmodal_item(!modal_item)
    removeBodyCss()
  }

  const tog_attachments = () => {
    setmodal_attachments(!modal_attachments)
    removeBodyCss()
  }

  const handleComments = () => {
    setIsEdit(false)
    setIsloading(true)
    tog_comments()
    setIsloading(false)
  }

  const handleDownload = clickedFile => {
    const base64String = clickedFile.FileContentsBase64
    const fileName = clickedFile.FileName
    const fileExtension = clickedFile.FileExtension
    const contentType = clickedFile.fileContentType
    downloadBase64File(base64String, fileName, fileExtension, contentType)
  }

  const removeFile = clickedFile => {
    const Config = {
      auth: {
        username: url.HRMIS,
        password: url.HRMISPASS,
      },
      headers: {
        "Content-Type": "application/json",
        "If-Match": "*",
      },
    }
    setIsloading(true)
    axios
      .delete(
        `${url.ATTACHDOCUMENTS}(${clickedFile.SystemId})?company=${CompanyID}`,
        Config
      )
      .then(r => {
        toastr.warning("File deleted")
        fetchData()
      })
      .catch(e => {
        console.log(e)
        toastr.error(e.response.data.error.message)
        setIsloading(false)
      })
  }

  const handleSelectedFiles = e => {
    const files = e.target.files
    setSelectedFile(Array.from(files))
  }

  const handleSaveFiles = () => {
    console.log(CompanyID)
    selectedFile.forEach(f => {
      const reader = new FileReader()
      reader.readAsDataURL(f)
      reader.onloadend = () => {
        const base64Data = reader.result
        const fileName = f.name
        const fileExtension = fileName.split(".").pop()
        const fileData = {
          No: rNo,
          TableID: 51402290,
          FileName: fileName,
          DocumentType: "Purchase Requisition",
          FileExtension: fileExtension,
          fileContentType: getContentTypeFromBase64(base64Data),
          FileContentsBase64: base64Data.split(",")[1],
        }
        setIsloading(true)
        axios
          .post(
            url.ATTACHDOCUMENTS + "?company=" + CompanyID,
            JSON.stringify(fileData),
            HRConfig
          )
          .then(r => {
            toastr.info(`${r.data.FileName} has been attached`)
            tog_attachments()
            fetchData()
          })
          .catch(e => {
            console.log(e)
            toastr.error(e.response.data.error.message)
            setIsloading(false)
          })
      }
    })
  }

  const tog_PlanningSpecifications = () => {
    axios
      .get(
        `${url.PLANNINGSPECIFICATIONS}?$filter=documentNo eq '${rNo}'and workplanNo eq '${workplanno}'and workplanEntry eq ${workPlanEntryNo} and purchaseLineNo eq ${lineNo} &company='${CompanyID}'`,
        HRConfig
      )
      .then(r => {
        setManagementActivities(r.data.value)
      })
      .catch(e => {
        console.log(e)
      })
    setmodal_PlanningSpecifications(!modal_PlanningSpecifications)
    removeBodyCss()
  }

  const handleEditManagement = k => {
    setAddDetails(true)
    setEditLine(true)
    setSpecificationID(managementActivities[k].id)
    setSpecification(managementActivities[k].specification)
    setPlannedDate(managementActivities[k].plannedDate)
    setUOM(managementActivities[k].unitmeasure)
    setCategory(managementActivities[k].category)
    setProcurementType(managementActivities[k].procurementType)
    setProcurementMethod(managementActivities[k].procurementMethod)
  }
  const handleUpdateManagementActivities = () => {
    const data = {
      documentNo: rNo,
      purchaseLineNo: lineNo,
      workplanNo: workplanno,
      workplanEntry: workPlanEntryNo,
      specification: specification,
      plannedDate: plannedDate,
      unitmeasure: uom,
      category: category,
      procurementType: procurementtype,
      procurementMethod: procurementmethod,
    }
    const Config = {
      auth: {
        username: url.HRMIS,
        password: url.HRMISPASS,
      },
      headers: {
        "Content-Type": "application/json",
        "If-Match": "*",
      },
    }
    axios
      .patch(
        `${url.PLANNINGSPECIFICATIONS}(${specificationid})?company=${CompanyID}`,
        JSON.stringify(data),
        Config
      )
      .then(r => {
        if (r.request.status == "200") {
          toastr.success("Planning Specification line modified successfully!")
          fetchData()
          tog_PlanningSpecifications()
          setSpecificationID("")
          clearPlanningSpecificationData()
        } else {
          toastr.error("Could not modify Planning Specification line!")
        }
        setIsloading(false)
      })
      .catch(function (error) {
        toastr.error(error.response.data.error.message)
        console.log(error)
        setIsloading(false)
      })
  }
  const handleDeleteManagement = k => {
    const Config = {
      auth: {
        username: url.HRMIS,
        password: url.HRMISPASS,
      },
      headers: {
        "Content-Type": "application/json",
        "If-Match": "*",
      },
    }
    axios
      .delete(
        `${url.PLANNINGSPECIFICATIONS}(${managementActivities[k].id})?company=${CompanyID}`,
        Config
      )
      .then(r => {
        if (r.request.status == "204") {
          toastr.success("Planning Specification line deleted successfully!")
          fetchData()
          tog_PlanningSpecifications()
          setSpecificationID("")
          clearPlanningSpecificationData()
        } else {
          toastr.error("Could not delete Planning Specification line!")
        }
        setIsloading(false)
      })
      .catch(function (error) {
        toastr.error(error.response.data.error.message)
        console.log(error)
        setIsloading(false)
      })
  }

  const handleAddManagement = () => {
    setIsloading(true)
    const Config = {
      auth: {
        username: url.HRMIS,
        password: url.HRMISPASS,
      },
      headers: {
        "Content-Type": "application/json",
        "If-Match": "*",
      },
    }
    const data = {
      documentNo: rNo,
      purchaseLineNo: lineNo,
      workplanNo: workplanno,
      workplanEntry: workPlanEntryNo,
      specification: specification,
      plannedDate: plannedDate,
      unitmeasure: uom,
      category: category,
      procurementType: procurementtype,
      procurementMethod: procurementmethod,
    }
    console.log(data)
    setIsloading(true)
    axios
      .post(
        url.PLANNINGSPECIFICATIONS + "?company=" + CompanyID,
        JSON.stringify(data),
        HRConfig
      )
      .then(r => {
        if (r.request.status == "201") {
          toastr.success("Planning Specification line added successfully!")
          fetchData()
          tog_PlanningSpecifications()
          clearPlanningSpecificationData()
        } else {
          toastr.error("Could not add Planning Specification line!")
        }
        setIsloading(false)
      })
      .catch(function (error) {
        toastr.error(error.response.data.error.message)
        console.log(error)
        setIsloading(false)
      })
  }

  toastr.options = TOAST_OPTIONS

  const fetchItemWorkplanEntryNo = newNo => {
    axios
      .get(
        url.ITEMS + "?$filter=no eq '" + newNo + "'&company=" + CompanyID,
        HRConfig
      )
      .then(function (response) {
        if (response.data.value.length > 0) {
          setGLControlAccount(response.data.value[0].GLControlAccount)
          axios
            .get(
              `${url.WORKPLANENTRYNO}?$filter=workPlanNo eq '${workplanno}' and gLAcccount eq '${response.data.value[0].GLControlAccount}' &company=${CompanyID}`,
              HRConfig
            )
            .then(r => {
              setWorkPlanEntry(r.data.value)
            })
            .catch(e => {
              console.log(e)
              setIsloading(false)
            })
        }
      })
  }

  const fetchGLWorkplanEntryNo = newNo => {
    axios
      .get(
        `${url.WORKPLANENTRYNO}?$filter=workPlanNo eq '${workplanno}' and gLAcccount eq '${newNo}' &company=${CompanyID}`,
        HRConfig
      )
      .then(r => {
        setWorkPlanEntry(r.data.value)
      })
      .catch(e => {
        console.log(e)
        setIsloading(false)
      })
  }

  const fetchFAWorkplanEntryNo = newNo => {
    axios
      .get(
        `${url.WORKPLANENTRYNO}?$filter=workPlanNo eq '${workplanno}' and gLAcccount eq '${newNo}' &company=${CompanyID}`,
        HRConfig
      )
      .then(r => {
        setWorkPlanEntry(r.data.value)
      })
      .catch(e => {
        console.log(e)
        setIsloading(false)
      })

    axios
      .get(
        url.FIXEDASSETS + "?$filter=no eq '" + newNo + "'&company=" + CompanyID,
        HRConfig
      )
      .then(function (response) {
        if (response.data.value.length > 0) {
          setGLControlAccount(response.data.value[0].GLControlAccount)
          axios
            .get(
              `${url.WORKPLANENTRYNO}?$filter=workPlanNo eq '${workplanno}' and gLAcccount eq '${response.data.value[0].GLControlAccount}' &company=${CompanyID}`,
              HRConfig
            )
            .then(r => {
              setWorkPlanEntry(r.data.value)
            })
            .catch(e => {
              console.log(e)
              setIsloading(false)
            })
        }
      })
  }

  const handleChange = event => {
    const name = event.target.name
    const value = event.target.value
    setInputs(values => ({ ...values, [name]: value }))
  }

  const handleNoChange = e => {
    setSelectedNo(e.value)
    if (selectedType == "Item") {
      fetchItemWorkplanEntryNo(e.value)
    }
    if (selectedType == "G/L Account") {
      fetchGLWorkplanEntryNo(e.value)
    }
    if (selectedType == "Fixed Asset") {
      fetchFAWorkplanEntryNo(e.value)
    }
  }

  const fetchWorkplanGLAccounts = async () => {
    axios
      .get(
        `${url.WORKPLANGLACCOUNTS}?$filter=workPlanNo eq '${workplanno}' &company=${CompanyID}`,
        HRConfig
      )
      .then(r => {
        let options = []
        r.data.value.map(a => {
          options.push({
            value: a.gLAcccount,
            label: `${a.gLAcccount} ${": "} ${a.accountName}`,
          })
        })
        setNoo(options)
        setWorkPlanGLAccounts(options)

        if (wkPlanGLAccounts.length > 0) {
          setIsloading(false)
        }
        setIsloading(false)
      })
      .catch(e => {
        console.log(e)
        setIsloading(false)
      })
  }

  const handleDelete = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "This will delete the Purchase requisition and its associated lines. You will not be able to recover this document!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#019654",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Proceed!",
      cancelButtonText: "Cancel",
    }).then(result => {
      if (result.isConfirmed) {
        setIsloading(true)
        const lNo = { no: rNo }
        axios
          .post(
            url.DELETERECORD + "?company=" + CompanyID,
            JSON.stringify(lNo),
            HRConfig
          )
          .then(function (response) {
            console.log(response)
            if (response.status == "200") {
              toastr.success("Purchase Requisition Deleted")
              history.push("/purchase-requisitions")
            } else {
              toastr.error("Could not Delete Purchase Requisition!")
            }
            setIsloading(false)
          })
          .catch(function (error) {
            toastr.error(error.response.data.error.message)
            console.log(error)
            setIsloading(false)
          })
      }
    })
  }
  const handleCancelApprovalRequest = e => {
    setIsloading(true)
    const lNo = { no: rNo }
    axios
      .post(
        url.PURCHREQNCANCELAPPROVAL + "?company=" + CompanyID,
        JSON.stringify(lNo),
        HRConfig
      )
      .then(function (response) {
        if (response.status == "200") {
          toastr.success("Approval Request Cancelled")
          history.go(0)
        } else {
          toastr.success("Could not Cancel Approval Request")
        }
        setIsloading(false)
      })
      .catch(function (error) {
        toastr.error(error.response.data.error.message)
        setIsloading(false)
      })
  }
  const handleDeleteLine2 = k => {
    Swal.fire({
      title: "Are you sure?",
      text: "This will delete the selected purchase requision line. You will not be able to recover it!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#019654",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(result => {
      if (result.isConfirmed) {
        setIsloading(true)
        const Config = {
          auth: {
            username: url.HRMIS,
            password: url.HRMISPASS,
          },
          headers: {
            "Content-Type": "application/json",
            "If-Match": "*",
          },
        }
        axios
          .delete(
            `${url.PURCHREQNLINES}(${lineSystemID})?company=${CompanyID}`,
            Config
          )
          .then(function (r) {
            if (r.status == "204") {
              setIsloading(false)
              toastr.info("Purchase requisition line deleted successfully")
              tog_item(false)
              fetchData()
              clearLineData()
            } else {
              toastr.error("Could not delete Purchase Requisition line!!")
              setIsloading(false)
            }
          })
          .catch(e => {
            console.log(e)
            setIsloading(false)
          })
      }
    })
  }
  const handleTypeChange = e => {
    setSelectedType(e.target.value)
    setIsloading(true)
    if (e.target.value == "Item") {
      setNoo(items)
      if (items.length > 0) {
        setIsloading(false)
      }
    } else if (e.target.value == "G/L Account") {
      fetchWorkplanGLAccounts()
    } else if (e.target.value == "Fixed Asset") {
      setNoo(fixedAssets)
      if (fixedAssets.length > 0) {
        setIsloading(false)
      }
    } else {
      setNoo([])
      setIsloading(false)
    }
  }

  const updateexpectedDeliveryDate = e => {
    if (RStatus != "Open") {
      toastr.error(
        "You cannot edit Purchase requisitions that have already been submitted for approval!"
      )
    } else {
      let newexpdeldate = e
      if (e != "") {
        let req = {}
        req = {
          expectedDeliverytDate: e,
        }
        toastr.info("Saving...")
        const Config = {
          auth: {
            username: url.HRMIS,
            password: url.HRMISPASS,
          },
          headers: {
            "Content-Type": "application/json",
            "If-Match": "*",
          },
        }
        axios
          .patch(
            `${url.PURCHASES1}(${id})?company=${CompanyID}`,
            JSON.stringify(req),
            Config
          )
          .then(function (response) {
            if (response.status == "200") {
              toastr.success("Saved")
              setExpectedDeliveryDate(newexpdeldate)
            } else {
              toastr.error("Could not save Expected Delivery date")
            }
            setIsloading(false)
          })
          .catch(function (error) {
            toastr.error(error.response.data.error.message)
            setIsloading(false)
          })
      }
    }
  }

  const updateexpectedReceiptDate = e => {
    if (RStatus != "Open") {
      toastr.error(
        "You cannot edit Purchase requisitions that have already been submitted for approval!"
      )
    } else {
      let newexprecdate = e
      if (e != "") {
        let req = {}
        req = {
          expectedReceiptDate: e,
        }
        toastr.info("Saving...")
        const Config = {
          auth: {
            username: url.HRMIS,
            password: url.HRMISPASS,
          },
          headers: {
            "Content-Type": "application/json",
            "If-Match": "*",
          },
        }
        axios
          .patch(
            `${url.PURCHASES1}(${id})?company=${CompanyID}`,
            JSON.stringify(req),
            Config
          )
          .then(function (response) {
            if (response.status == "200") {
              toastr.success("Saved")
              setExpectedReceiptDate(newexprecdate)
            } else {
              toastr.error("Could not save Expected Receipt date")
            }
            setIsloading(false)
          })
          .catch(function (error) {
            toastr.error(error.response.data.error.message)
            setIsloading(false)
          })
      }
    }
  }

  const updateProcurementType = e => {
    let newform = e.target.value
    if (e.target.value != "") {
      let req = {}
      req = {
        procurementType: e.target.value,
      }
      toastr.info("Saving...")
      const Config = {
        auth: {
          username: url.HRMIS,
          password: url.HRMISPASS,
        },
        headers: {
          "Content-Type": "application/json",
          "If-Match": "*",
        },
      }
      axios
        .patch(
          `${url.PURCHASES1}(${id})?company=${CompanyID}`,
          JSON.stringify(req),
          Config
        )
        .then(function (response) {
          if (response.status == "200") {
            toastr.success("Saved")
            setForm(newform)
          } else {
            toastr.error("Could not save Procurement type")
          }
          setIsloading(false)
        })
        .catch(function (error) {
          toastr.error(error.response.data.error.message)
          setIsloading(false)
        })
    }
  }

  const updateLocationCode = e => {
    let newlocation = e.target.value
    if (e.target.value != "") {
      let req = {}
      req = {
        locationCode: e.target.value,
      }
      toastr.info("Saving...")
      const Config = {
        auth: {
          username: url.HRMIS,
          password: url.HRMISPASS,
        },
        headers: {
          "Content-Type": "application/json",
          "If-Match": "*",
        },
      }
      axios
        .patch(
          `${url.PURCHASES1}(${id})?company=${CompanyID}`,
          JSON.stringify(req),
          Config
        )
        .then(function (response) {
          if (response.status == "200") {
            toastr.success("Saved")
            setLocationCode1(newlocation)
          } else {
            toastr.error("Could not save Location code")
          }
          setIsloading(false)
        })
        .catch(function (error) {
          toastr.error(error.response.data.error.message)
          setIsloading(false)
        })
    }
  }

  const handleChangeWorkPlanNo = e => {
    let newWPNo2 = e.target.value
    if (
      workplanno != "" &&
      e.target.value != workplanno &&
      purchaseRequisitionLines.length > 0
    ) {
      Swal.fire({
        title: "Are you sure?",
        text: "Modifying the Workplan No. will delete all associated purchase requisition lines. This action is irreversible. Do you wish to proceed?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#019654",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Proceed!",
      }).then(result => {
        if (result.isConfirmed) {
          setIsloading(true)
          const Config = {
            auth: {
              username: url.HRMIS,
              password: url.HRMISPASS,
            },
            headers: {
              "Content-Type": "application/json",
              "If-Match": "*",
            },
          }
          axios
            .get(
              `${url.PURCHREQNLINES}?$filter=documentNo eq '${rNo}' &company=${CompanyID}`,
              Config
            )
            .then(res => {
              let resObj = res.data.value
              resObj.forEach((obj, index) => {
                console.log(resObj)
                const Config = {
                  auth: {
                    username: url.HRMIS,
                    password: url.HRMISPASS,
                  },
                  headers: {
                    "Content-Type": "application/json",
                    "If-Match": "*",
                  },
                }
                axios
                  .delete(
                    `${url.PURCHREQNLINES}(${obj.id})?company=${CompanyID}`,
                    Config
                  )
                  .then(response => {
                    setIsloading(false)
                    setWorkPlanNo(newWPNo2)
                    handleChangeWorkPlanNo2(newWPNo2)
                  })
                  .catch(error => {
                    toastr.error(error.response.data.error.message)
                    setIsloading(false)
                  })
              })
              if (resObj.length == 0) {
                toastr.info(
                  "Purchase requisition Lines have been cleared. You can now create new lines."
                )
                setIsloading(false)
                setWorkPlanNo(newWPNo2)
                handleChangeWorkPlanNo2(newWPNo2)
              }
            })
            .catch(err => {
              toastr.error(err.response.data.error.message)
              setIsloading(false)
            })
        }
      })
    }
    if (workplanno != "" && purchaseRequisitionLines.length == 0) {
      setWorkPlanNo(e.target.value)
      let req = {}
      req = {
        workPlanNo: e.target.value,
      }
      toastr.info("Saving...")
      const Config = {
        auth: {
          username: url.HRMIS,
          password: url.HRMISPASS,
        },
        headers: {
          "Content-Type": "application/json",
          "If-Match": "*",
        },
      }
      axios
        .patch(
          `${url.PURCHASES1}(${id})?company=${CompanyID}`,
          JSON.stringify(req),
          Config
        )
        .then(function (response) {
          if (response.status == "200") {
            toastr.success("Saved")
          } else {
            toastr.error("Could not save work plan No.")
          }
          setIsloading(false)
        })
        .catch(function (error) {
          toastr.error(error.response.data.error.message)
          setIsloading(false)
        })
    }
    if (workplanno == "" && purchaseRequisitionLines.length == 0) {
      setWorkPlanNo(e.target.value)
      let req = {}
      req = {
        workPlanNo: e.target.value,
      }
      toastr.info("Saving...")
      const Config = {
        auth: {
          username: url.HRMIS,
          password: url.HRMISPASS,
        },
        headers: {
          "Content-Type": "application/json",
          "If-Match": "*",
        },
      }
      axios
        .patch(
          `${url.PURCHASES1}(${id})?company=${CompanyID}`,
          JSON.stringify(req),
          Config
        )
        .then(function (response) {
          if (response.status == "200") {
            toastr.success("Saved")
          } else {
            toastr.error("Could not save Work Plan No.")
          }
          setIsloading(false)
        })
        .catch(function (error) {
          toastr.error(error.response.data.error.message)
          setIsloading(false)
        })
    }
  }

  const handleChangeWorkPlanNo2 = newWPNo2 => {
    if (newWPNo2 != "") {
      let req = {}
      req = {
        workPlanNo: newWPNo2,
      }
      const Config = {
        auth: {
          username: url.HRMIS,
          password: url.HRMISPASS,
        },
        headers: {
          "Content-Type": "application/json",
          "If-Match": "*",
        },
      }
      axios
        .patch(
          `${url.PURCHASES1}(${id})?company=${CompanyID}`,
          JSON.stringify(req),
          Config
        )
        .then(function (response) {
          if (response.status == "200") {
            toastr.success(
              "Purchase requisition lines deleted. You can now create new lines.",
              "Please Wait..."
            )
            fetchData()
          } else {
            toastr.error(
              "Could not save Work plan No. Please re-load the page and try again!"
            )
          }
          setIsloading(false)
        })
        .catch(function (error) {
          toastr.error(error.response.data.error.message)
          setIsloading(false)
        })
    }
  }

  const updateprocurementplanreference = e => {
    if (e.target.value != "") {
      let req = {}
      req = {
        ProcumentPlanReference: e.target.value,
      }
      toastr.info("Saving...")
      const Config = {
        auth: {
          username: url.HRMIS,
          password: url.HRMISPASS,
        },
        headers: {
          "Content-Type": "application/json",
          "If-Match": "*",
        },
      }
      axios
        .patch(
          `${url.PURCHASES1}(${id})?company=${CompanyID}`,
          JSON.stringify(req),
          Config
        )
        .then(function (response) {
          if (response.status == "200") {
            toastr.success("Saved")
          } else {
            toastr.error("Could not save Procurement plan Reference")
          }
          setIsloading(false)
        })
        .catch(function (error) {
          toastr.error(error.response.data.error.message)
          setIsloading(false)
        })
    }
  }

  const updatesubjectofprocurement = e => {
    if (e.target.value != "") {
      let req = {}
      req = {
        procurementDescription: e.target.value,
      }
      toastr.info("Saving...")
      const Config = {
        auth: {
          username: url.HRMIS,
          password: url.HRMISPASS,
        },
        headers: {
          "Content-Type": "application/json",
          "If-Match": "*",
        },
      }
      axios
        .patch(
          `${url.PURCHASES1}(${id})?company=${CompanyID}`,
          JSON.stringify(req),
          Config
        )
        .then(function (response) {
          if (response.status == "200") {
            toastr.success("Saved")
          } else {
            toastr.error("Could not save Subject of Procurement")
          }
          setIsloading(false)
        })
        .catch(function (error) {
          toastr.error(error.response.data.error.message)
          setIsloading(false)
        })
    }
  }
  const handleAddItem = () => {
    setIsEdit(false)
    setIsloading(true)
    tog_item()
    setSelectedType("")
    setSelectedNo("")
    setWorkPlanEntryNo("")
    setQuantity("")
    setDescription2("")
    setDirectUnitCost("")
    setLineSystemId("")
  }

  const handleEditLine = k => {
    const p = purchaseRequisitionLines[k]
    setIsEdit(true)
    setIsloading(true)
    fetchItemWorkplanEntryNo(p.no)
    fetchFAWorkplanEntryNo(p.no)
    fetchGLWorkplanEntryNo(p.no)
    tog_item()
    setSelectedType(p.accountType)
    setSelectedNo(p.no)
    setWorkPlanEntryNo(p.workPlanEntryNo)
    setQuantity(p.quantity)
    setDescription2(p.description2)
    setDirectUnitCost(p.directUnitCost)
    setLineSystemId(p.id)
    setLineNo(p.lineNo)

    if (p.accountType == "Item") {
      fetchItms()
      //setNoo(items)
      setIsloading(false)
    } else if (p.accountType == "G/L Account") {
      fetchWorkplanGLAccounts()
      setIsloading(false)
    } else if (p.accountType == "Fixed Asset") {
      fetchFA()
      setIsloading(false)
    } else {
      setNoo([])
      setIsloading(false)
    }
  }

  const fetchFA = async () => {
    axios
      .get(url.FIXEDASSETS + "?company=" + CompanyID, HRConfig)
      .then(r => {
        let options = []
        r.data.value.map(a => {
          options.push({
            value: a.no,
            label: `${a.no} ${": "} ${a.description}`,
          })
        })
        setFixedAssets(options)
        setNoo(options)
      })
      .catch(e => {
        console.log(e)
      })
    setIsloading(false)
  }

  const fetchItms = async () => {
    axios
      .get(url.ITEMS + "?company=" + CompanyID, HRConfig)
      .then(r => {
        let options = []
        r.data.value.map(a => {
          options.push({
            value: a.no,
            label: `${a.no} ${": "} ${a.description}`,
          })
        })
        setItems(options)
        setNoo(options)
      })
      .catch(e => {
        console.log(e)
      })
    setIsloading(false)
  }

  const clearLineData = () => {
    setSelectedType("")
    setSelectedNo("")
    setWorkPlanEntryNo("")
    setDescription2("")
    setQuantity("")
    setDirectUnitCost("")
    setLineSystemId("")
  }

  const clearPlanningSpecificationData = () => {
    setSpecification("")
    setPlannedDate("")
    setUOM("")
    setCategory("")
    setProcurementType("")
    setProcurementMethod("")
  }

  const handleApprovalRequest = e => {
    //this is not mandatory : muhammad 15th March 2024
    // if (procumentPlanReference == ""){
    //     toastr.error("Procurement Plan Reference must not be blank!");
    // } else
    if (locationCode1 == "") {
      toastr.error("Location code must not be blank!")
    } else if (form == "") {
      toastr.error("Procurement Type must not be blank!")
    } else if (expecteddeliverydate == "") {
      toastr.error("Expected delivery date must not be blank!")
    } else if (expectedreceiptdate == "") {
      toastr.error("Expected receipt date must not be blank!")
    } else if (subject == "") {
      toastr.error("Subject of procurement must not be blank!")
    } else if (workplanno == "") {
      toastr.error("Work Plan Number must not be blank!")
    } else {
      Swal.fire({
        title: "Are you sure?",
        text: "This will send the Purchase requisition and its associated lines for approval. Do you wish to proceed?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#019654",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Proceed!",
        cancelButtonText: "Cancel",
      }).then(result => {
        if (result.isConfirmed) {
          setIsloading(true)
          const lNo = { no: rNo }
          axios
            .post(
              url.PURCHREQNAPPROVALREQUEST + "?company=" + CompanyID,
              JSON.stringify(lNo),
              HRConfig
            )
            .then(function (response) {
              if (response.status == "200") {
                toastr.success(
                  "Purchase requisition has been sent for Approval"
                )
                history.go(0)
              } else {
                toastr.success(
                  "Could not send purchase requisition for Approval"
                )
              }
              setIsloading(false)
            })
            .catch(function (error) {
              toastr.error(error.response.data.error.message)
              setIsloading(false)
              console.log(error)
            })
            .then(function () {
              setIsloading(false)
              // always executed
            })
        }
      })
    }
  }
  const handleAddLine2 = () => {
    setIsloading(true)
    const Config = {
      auth: {
        username: url.HRMIS,
        password: url.HRMISPASS,
      },
      headers: {
        "Content-Type": "application/json",
        "If-Match": "*",
      },
    }
    const data = {
      documentNo: rNo,
      accountType: selectedType,
      no: selectedNo,
      workPlanEntryNo: workPlanEntryNo,
      description2: description2,
      quantity: parseInt(quantity),
      directUnitCost: parseInt(directUnitCost),
    }
    axios
      .post(
        `${url.PURCHREQNLINES}?company='${CompanyID}'`,
        JSON.stringify(data),
        Config
      )
      .then(r => {
        if (r.request.status == "201") {
          toastr.success("Purchase Requisition updated successfully!")
          tog_item(false)
          fetchData()
          clearLineData()
        } else {
          toastr.error("Could not update purchase requisition!")
        }
        setIsloading(false)
      })
      .catch(e => {
        console.log(e)
        setIsloading(false)
      })
  }
  const handleUpdateLine2 = () => {
    setIsloading(true)
    const Config = {
      auth: {
        username: url.HRMIS,
        password: url.HRMISPASS,
      },
      headers: {
        "Content-Type": "application/json",
        "If-Match": "*",
      },
    }
    const data = {
      accountType: selectedType,
      no: selectedNo,
      workplanno: workplanno,
      workPlanEntryNo: workPlanEntryNo,
      description2: description2,
      quantity: parseInt(quantity),
      directUnitCost: parseInt(directUnitCost),
    }
    axios
      .patch(
        `${url.PURCHREQNLINES}(${lineSystemID})?company=${CompanyID}`,
        JSON.stringify(data),
        Config
      )
      .then(function (response) {
        if (response.request.status == "200") {
          toastr.success("Purchase Requisition updated successfully")
          tog_item(false)
          fetchData()
          clearLineData()
        } else {
          toastr.error("Could not update purchase requisition!!")
        }
        setIsloading(false)
      })
      .catch(function (error) {
        console.log(error)
        toastr.error(error.response.data.error.message)
        setIsloading(false)
      })
  }

  const fetchData = () => {
    let obj = JSON.parse(localStorage.getItem("authMildUser"))
    let EmployeeNo = obj.uid
    setCompanyID(obj.activeCompany)
    setIsloading(true)
    axios
      .get(
        url.PURCHASES1 +
          "(" +
          id +
          ")?$expand=purchaseRequisitionLines" +
          "&company=" +
          obj.activeCompany,
        HRConfig
      )
      .then(function (r) {
        setRNo(r.data.no)
        setEmpNo(r.data.requestorNo)
        setEmpName(r.data.requestorName)
        setWorkPlanNo(r.data.workPlanNo)
        setSubject(r.data.procurementDescription)
        setForm(r.data.procurementType)
        setPostingDate(r.data.PostingDate)
        setSuppliesWorksServices(r.data.SuppliesWorksServices)
        setBudgetName(r.data.BudgetName)
        setProcurementPlanReference(r.data.ProcumentPlanReference)
        setCurrencyCode(r.data.CurrencyCode)
        setLocationCode1(r.data.locationCode)
        setPurchaseRequisitionLines(r.data.purchaseRequisitionLines)
        setRStatus(r.data.status)
        setExpectedReceiptDate(r.data.expectedReceiptDate)
        setExpectedDeliveryDate(r.data.expectedDeliverytDate)
        setValidtoDate(r.data.validtodate)
        setIsloading(false)
        setLoadingFiles(true)

        axios
          .get(
            `${url.EMPLOYEES2}?$filter=No eq '${r.data.requestorNo}'&company=${obj.activeCompany}`,
            HRConfig
          )
          .then(r => {
            setEmpTitle(r.data.value[0].JobTitle)
            setDepartmentCode(r.data.value[0].Department_Code)
            const dc = setDepartmentCode(r.data.value[0].Department_Code)
            setUserError(false)
          })
          .catch(e => {
            console.log(e)
            setIsloading(false)
          })
        axios
          .get(url.UNITOFMEASURE + "?company=" + obj.activeCompany, HRConfig)
          .then(r => {
            setUnitOfMeasure(r.data.value)
          })
          .catch(e => {
            console.log(e)
            setIsloading(false)
          })
        axios
          .get(url.LOCATIONS + "?company=" + obj.activeCompany, HRConfig)
          .then(r => {
            setLocations(r.data.value)
          })
          .catch(e => {
            console.log(e)
            setIsloading(false)
          })
        axios
          .get(
            `${url.WORKPLANS}?$filter=department eq '${r.data.BusinessUnit}' &company=${obj.activeCompany}`,
            HRConfig
          )
          .then(r => {
            setWorkPlans(r.data.value)
          })
          .catch(e => {
            console.log(e)
            setIsloading(false)
          })
        axios
          .get(
            `${url.WORKPLANENTRYNO}?$filter=workPlanNo eq '${r.data.workPlanNo}' and gLAcccount eq '${selectedNo}' &company=${obj.activeCompany}`,
            HRConfig
          )
          .then(r => {
            setWorkPlanEntry(r.data.value)
            console
          })
          .catch(e => {
            console.log(e)
            setIsloading(false)
          })
        axios
          .get(url.GLACCOUNTS + "?company=" + obj.activeCompany, HRConfig)
          .then(r => {
            let options = []
            r.data.value.map(a => {
              options.push({ value: a.no, label: `${a.no} ${": "} ${a.name}` })
            })
            setGLAccounts(options)
          })
          .catch(e => {
            console.log(e)
          })
        axios
          .get(url.ITEMS + "?company=" + obj.activeCompany, HRConfig)
          .then(r => {
            let options = []
            r.data.value.map(a => {
              options.push({
                value: a.no,
                label: `${a.no} ${": "} ${a.description}`,
              })
            })
            setItems(options)
          })
          .catch(e => {
            console.log(e)
          })
        axios
          .get(
            `${url.APPROVALCOMMENTS}?$filter=document_Type eq 'Purchase Requisition' and document_No eq '${r.data.no}' &company=${obj.activeCompany}`,
            HRConfig
          )
          .then(r => {
            setApprovalCommentLines(r.data.value)
          })
        axios
          .get(
            `${url.ATTACHDOCUMENTS}?$filter=DocumentType eq 'Purchase Requisition' and No eq '${r.data.no}' &company=${obj.activeCompany}`,
            HRConfig
          )
          .then(rx => {
            setUploadedFiles(rx.data.value)
            setLoadingFiles(false)
          })
          .catch(ex => {
            console.log(ex)
            setLoadingFiles(false)
          })
        axios
          .get(url.FIXEDASSETS + "?company=" + obj.activeCompany, HRConfig)
          .then(r => {
            let options = []
            r.data.value.map(a => {
              options.push({
                value: a.no,
                label: `${a.no} ${": "} ${a.description}`,
              })
            })
            setFixedAssets(options)
          })
          .catch(e => {
            console.log(e)
          })
        setIsloading(false)
        setUserError(false)
      })
      .catch(function (error) {
        toastr.error(error.response.data.error.message)
        setUserError(true)
        console.log(error)
        setIsloading(false)
      })
  }
  useEffect(() => {
    fetchData()
    return () => {
      setState({})
    }
  }, [])

  return (
    <LoadingOverlay
      active={isloading}
      spinner={<ClimbingBoxLoader />}
      text="Please wait..."
    >
      <div className="page-content">
        <MetaTags>
          <title>Purchase Requisition Details | BRIDGE</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumbs
            title="Purchase Management"
            breadcrumbItem="Purchase Requisition"
          />
          <Row className="justify-content-center mb-4">
            <div className="d-flex flex-wrap gap-5">
              {purchaseRequisitionLines.length > 0 && RStatus == "Open" && (
                <Button
                  color="primary"
                  className="btn btn-primary btn-label waves-effect waves-light"
                  onClick={handleApprovalRequest}
                >
                  <i className="bx bx-send label-icon" /> Submit Purchase
                  Requisition for Approval
                </Button>
              )}
              {RStatus == "Open" && (
                <Button
                  color="danger"
                  className="btn btn-primary btn-label waves-effect waves-light"
                  onClick={() => {
                    handleDelete()
                  }}
                >
                  <i className="bx bx-trash label-icon" /> Delete Purchase
                  Requisition
                </Button>
              )}
              {RStatus == "Pending Approval" && (
                <Button
                  color="danger"
                  className="btn btn-primary btn-label waves-effect waves-light"
                  onClick={handleCancelApprovalRequest}
                >
                  <i className="mdi mdi-book-cancel-outline label-icon" />{" "}
                  Cancel Approval Request
                </Button>
              )}
              {approvalCommentLines.length > 0 && (
                <Button
                  color="info"
                  className="btn btn-primary btn-label waves-effect waves-light"
                  onClick={handleComments}
                >
                  <i className="bx bx-book-content label-icon" /> Rejection
                  Comments
                </Button>
              )}
            </div>
          </Row>

          <div>
            {userError && (
              <Alert color="danger" role="alert">
                Details Not Found in Dynamics 365 Business Central
              </Alert>
            )}

            {ipaSaved == false ? (
              <Row>
                <Col xl={4}>
                  <Card>
                    <CardBody>
                      <CardTitle>Employee Details</CardTitle>
                      <div className="table-responsive">
                        <table className="table">
                          <tbody>
                            <tr>
                              <th scope="col"> Number</th>
                              <td scope="col"> {empNo} </td>
                            </tr>
                            <tr>
                              <th scope="col"> Name</th>
                              <td scope="col">{empName}</td>
                            </tr>
                            <tr>
                              <th scope="col">Position</th>
                              <td scope="col">{empTitle}</td>
                            </tr>
                            <tr>
                              <th scope="col">Department</th>
                              <td scope="col">{departmentcode}</td>
                            </tr>
                            <tr>
                              <th scope="col">Status</th>
                              <td scope="col">{RStatus}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </CardBody>
                  </Card>
                  <div className="d-flex">
                    <div className="flex-grow-1 ms-1">
                      <ul className="list-unstyled vstack gap-2 mb-0">
                        <div className="d-grid gap-2">
                          {/* {(RStatus == 'Open') && (
                                            <Button color="warning" type="button" className="btn btnSubmitPlan" onClick={()=>{handleAddItem()}} >
                                                <i className="mdi mdi-cart-arrow-down"/>{" "}
                                                    Add Purchase Requisition Line
                                            </Button>
                                            )} */}
                          {/* {(purchaseRequisitionLines.length > 0) && (RStatus == 'Open') && (
                                            <Button color="primary" type="button" className="btn btnSubmitPlan" onClick={handleApprovalRequest}>
                                                <i className="mdi mdi-clipboard-check-outline"/>{" "}
                                                    Submit Purchase Requisition for Approval
                                            </Button>
                                            )}
                                            {(RStatus == 'Open') && (
                                                <Button color="danger" type="button" className="btn btnSubmitPlan" onClick={()=>{handleDelete()}} >
                                                    <i className="mdi mdi-delete"/>{" "}
                                                        Delete Purchase Requisition
                                                </Button>
                                            )} */}
                          {/* {(RStatus == 'Open') && (
                                                <Button color="info" type="button" className="btn btnSubmitPlan" onClick={tog_attachments} >
                                                    <i className="mdi mdi-file"/>{" "}
                                                        Attachments
                                                </Button>
                                            )} */}
                          {/* {(RStatus == 'Pending Approval') && (
                                            <Button color="danger" type="button" className="btn btnSubmitPlan" onClick={handleCancelApprovalRequest}>
                                                <i className="mdi mdi-book-cancel-outline"/>{" "}
                                                    Cancel Approval Request
                                            </Button>
                                            )}
                                            {(approvalCommentLines.length > 0) && (
                                                <Button color="info" type="button" className="btn btnSubmitPlan" onClick={handleComments}>
                                                    <i className="mdi mdi-cart-arrow-down"/>{" "}
                                                        View Rejection Comments
                                                </Button>
                                            )} */}
                        </div>
                      </ul>
                    </div>
                  </div>

                  <Card>
                    <CardBody>
                      <CardTitle>
                        <Row className="mb-2">
                          <Col sm={6}>Attachments ({uploadedFiles.length})</Col>

                          {RStatus == "Open" && (
                            <Col sm={6}>
                              <div className="text-sm-end">
                                <Button
                                  color="primary"
                                  className="btn btn-primary btn-label waves-effect waves-light"
                                  type="button"
                                  onClick={tog_attachments}
                                >
                                  <i className="mdi mdi-file-plus-outline label-icon" />{" "}
                                  Add File
                                </Button>
                              </div>
                            </Col>
                          )}
                        </Row>
                      </CardTitle>
                      {loadingFiles ? (
                        <>
                          <div className="text-center">
                            <div className="mb-4"></div>
                            <div>
                              <h5>Loading files ...</h5>
                              <p className="text-muted"></p>
                            </div>
                          </div>
                        </>
                      ) : uploadedFiles.length > 0 ? (
                        <div className="table-responsive">
                          <Table className="table table-striped table-sm mb-4">
                            <thead>
                              <tr>
                                <th>File</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              {uploadedFiles.map((a, k) => (
                                <tr key={k}>
                                  <td style={{ verticalAlign: "middle" }}>
                                    <Link
                                      to="#"
                                      onClick={() =>
                                        handleDownload(uploadedFiles[k])
                                      }
                                    >
                                      {a.FileName}
                                    </Link>
                                  </td>
                                  <td
                                    style={{
                                      verticalAlign: "middle",
                                      textAlign: "center",
                                    }}
                                  >
                                    {" "}
                                    <>
                                      <div className="d-flex gap-3">
                                        {RStatus == "Open" && (
                                          <Link
                                            to="#"
                                            className="text-danger"
                                            onClick={() =>
                                              removeFile(uploadedFiles[k])
                                            }
                                          >
                                            <i
                                              className="mdi mdi-delete font-size-18"
                                              id="deletetooltip"
                                            />
                                            <UncontrolledTooltip
                                              placement="top"
                                              target="deletetooltip"
                                            >
                                              Delete
                                            </UncontrolledTooltip>
                                          </Link>
                                        )}
                                      </div>
                                    </>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      ) : (
                        <div className="text-center">
                          <div className="mb-4">
                            <i className="mdi mdi-file text-warning display-4" />
                          </div>
                          <div>
                            <h5>No files attached, yet!</h5>
                            <p className="text-muted"></p>
                          </div>
                        </div>
                      )}
                    </CardBody>
                  </Card>
                </Col>
                <Col xl={8}>
                  <Card>
                    <CardBody>
                      <CardTitle>Requisition Details</CardTitle>
                      <div className="table-responsive">
                        <Row>
                          <Col md={12}>
                            <table className="table">
                              <tbody>
                                <tr>
                                  <th scope="col">No.</th>
                                  <td scope="col">{rNo}</td>
                                </tr>
                                <tr>
                                  <th scope="col"> Work Plan No.</th>
                                  <td scope="col">
                                    <select
                                      className="form-select"
                                      value={workplanno}
                                      onChange={e => handleChangeWorkPlanNo(e)}
                                      disabled={
                                        RStatus == "Open" ? false : true
                                      }
                                    >
                                      <option value="">Select</option>
                                      {workplans.map((l, k) => (
                                        <option key={k} value={l.no}>
                                          {l.no}
                                        </option>
                                      ))}
                                    </select>
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="col">Proc. Plan Reference</th>
                                  <td scope="col">
                                    <p className="text-muted fs-14 mb-0">
                                      <input
                                        className="form-control"
                                        type="text"
                                        value={procumentPlanReference}
                                        onChange={e =>
                                          setProcurementPlanReference(
                                            e.target.value
                                          )
                                        }
                                        onBlur={updateprocurementplanreference}
                                        disabled={
                                          RStatus == "Open" ? false : true
                                        }
                                      />
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="col">Location Code</th>
                                  <td scope="col">
                                    <select
                                      className="form-select"
                                      value={locationCode1}
                                      onChange={e => updateLocationCode(e)}
                                      disabled={
                                        RStatus == "Open" ? false : true
                                      }
                                    >
                                      <option value="">Select</option>
                                      {locations.map((l, k) => (
                                        <option key={k} value={l.code}>
                                          {l.name}
                                        </option>
                                      ))}
                                    </select>
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="col"> Expected Receipt Date</th>
                                  <td scope="col">
                                    {
                                      <Flatpickr
                                        className="form-control"
                                        value={expectedreceiptdate}
                                        onChange={e =>
                                          updateexpectedReceiptDate(
                                            formatDate(e)
                                          )
                                        }
                                        options={{
                                          altInput: true,
                                          altFormat: "F j, Y",
                                          dateFormat: "Y-m-d",
                                          disabled: true,
                                        }}
                                      />
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="col">Expected Delivery Date</th>
                                  <td scope="col">
                                    {
                                      <Flatpickr
                                        className="form-control"
                                        value={expecteddeliverydate}
                                        onChange={e =>
                                          updateexpectedDeliveryDate(
                                            formatDate(e)
                                          )
                                        }
                                        options={{
                                          altInput: true,
                                          altFormat: "F j, Y",
                                          dateFormat: "Y-m-d",
                                          disabled: true,
                                        }}
                                      />
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="col">Procurement Type</th>
                                  <td scope="col">
                                    <select
                                      className="form-select"
                                      value={form}
                                      onChange={e => updateProcurementType(e)}
                                      disabled={
                                        RStatus == "Open" ? false : true
                                      }
                                    >
                                      <option value="">Select</option>
                                      <option value="Contracts">
                                        Contracts
                                      </option>
                                      <option value="LPO">LPO</option>
                                      <option value="Direct Invoice">
                                        Direct Invoice
                                      </option>
                                    </select>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </Col>

                          <Col md={12}>
                            <label htmlFor="floatingDepartInput">
                              {" "}
                              <h6> Subject of Procurement</h6>
                            </label>
                            <div className="form-floating mb-3">
                              <input
                                type="text"
                                className="form-control"
                                value={subject}
                                onChange={e => setSubject(e.target.value)}
                                onBlur={updatesubjectofprocurement}
                                disabled={RStatus == "Open" ? false : true}
                              />
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg={12}>
                  <Card>
                    <CardBody>
                      <CardTitle>
                        <Row className="mb-2">
                          <Col sm={6}>
                            Purchase Requisition Lines (
                            {purchaseRequisitionLines.length})
                          </Col>

                          {RStatus == "Open" &&
                            workplanno != "" &&
                            locationCode1 != "" &&
                            expectedreceiptdate != "" &&
                            subject != "" && (
                              <Col sm={6}>
                                <div className="text-sm-end">
                                  <Button
                                    color="primary"
                                    className="btn btn-primary btn-label waves-effect waves-light"
                                    onClick={() => {
                                      handleAddItem()
                                    }}
                                  >
                                    <i className="mdi mdi-cart-arrow-down label-icon" />{" "}
                                    Add Purchase Requisition Line
                                  </Button>
                                </div>
                              </Col>
                            )}
                        </Row>
                      </CardTitle>
                      <CardBody className="border-bottom">
                        {purchaseRequisitionLines.length > 0 ? (
                          <div className="table-responsive">
                            <Table className="table table-striped table-sm mb-4">
                              <thead>
                                <tr>
                                  <th
                                    style={{
                                      verticalAlign: "middle",
                                      textAlign: "center",
                                    }}
                                  >
                                    Type
                                  </th>
                                  <th
                                    style={{
                                      verticalAlign: "middle",
                                      textAlign: "center",
                                    }}
                                  >
                                    No
                                  </th>
                                  <th
                                    style={{
                                      verticalAlign: "middle",
                                      textAlign: "center",
                                    }}
                                  >
                                    WorkPlan Entry No
                                  </th>
                                  <th
                                    style={{
                                      verticalAlign: "middle",
                                      textAlign: "center",
                                    }}
                                  >
                                    Description 2
                                  </th>
                                  <th
                                    style={{
                                      verticalAlign: "middle",
                                      textAlign: "center",
                                    }}
                                  >
                                    Quantity
                                  </th>
                                  <th
                                    style={{
                                      verticalAlign: "middle",
                                      textAlign: "center",
                                    }}
                                  >
                                    Estimated Unit Cost
                                  </th>
                                  <th
                                    style={{
                                      verticalAlign: "middle",
                                      textAlign: "center",
                                    }}
                                  >
                                    Line Amount
                                  </th>
                                  <th
                                    style={{
                                      verticalAlign: "middle",
                                      textAlign: "center",
                                    }}
                                  ></th>
                                </tr>
                              </thead>
                              <tbody>
                                {purchaseRequisitionLines.map((a, k) => (
                                  <tr key={k}>
                                    <td
                                      style={{
                                        verticalAlign: "middle",
                                        textAlign: "center",
                                      }}
                                    >
                                      {a.accountType}
                                    </td>
                                    <td
                                      style={{
                                        verticalAlign: "middle",
                                        textAlign: "center",
                                      }}
                                    >
                                      {a.no}
                                    </td>
                                    <td
                                      style={{
                                        verticalAlign: "middle",
                                        textAlign: "center",
                                      }}
                                    >
                                      {a.workPlanEntryNo}
                                    </td>
                                    <td
                                      style={{
                                        verticalAlign: "middle",
                                        textAlign: "center",
                                      }}
                                    >
                                      {a.description2}
                                    </td>
                                    <td
                                      style={{
                                        verticalAlign: "middle",
                                        textAlign: "center",
                                      }}
                                    >
                                      {a.quantity.toLocaleString("en-UG")}
                                    </td>
                                    <td
                                      style={{
                                        verticalAlign: "middle",
                                        textAlign: "center",
                                      }}
                                    >
                                      {a.directUnitCost.toLocaleString("en-UG")}
                                    </td>
                                    <td
                                      style={{
                                        verticalAlign: "middle",
                                        textAlign: "center",
                                      }}
                                    >
                                      {a.lineAmount.toLocaleString("en-UG")}
                                    </td>
                                    <td
                                      style={{
                                        verticalAlign: "middle",
                                        textAlign: "center",
                                      }}
                                    >
                                      {" "}
                                    </td>
                                    <td
                                      style={{
                                        verticalAlign: "middle",
                                        textAlign: "center",
                                      }}
                                    >
                                      {/* {(RStatus == 'Open') && ( */}
                                      <div className="d-flex gap-3">
                                        <Link
                                          to="#"
                                          className="text-primary"
                                          onClick={() => {
                                            handleEditLine(k)
                                          }}
                                        >
                                          <i
                                            className="mdi mdi-pencil font-size-18"
                                            id="edittooltip"
                                          />
                                          <UncontrolledTooltip
                                            placement="top"
                                            target="edittooltip"
                                          >
                                            Edit
                                          </UncontrolledTooltip>
                                        </Link>
                                      </div>
                                      {/* )} */}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </div>
                        ) : (
                          <div className="text-center">
                            <div className="mb-4">
                              <i className="mdi mdi-cart-arrow-down text-warning display-4" />
                            </div>
                            <div>
                              <h5>No Purchase Requisition Lines added, yet!</h5>
                            </div>
                          </div>
                        )}
                      </CardBody>

                      <Modal
                        isOpen={modal_item}
                        toggle={() => {
                          tog_item()
                        }}
                        size="l"
                        centered
                        backdrop={"static"}
                      >
                        <div className="modal-header">
                          <h5 className="modal-title mt-0" id="myModalLabel">
                            {isEdit ? `Update/Delete ` : `Add `}Purchase
                            Requisition Line
                          </h5>
                          <button
                            type="button"
                            onClick={() => {
                              setmodal_item(false)
                            }}
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div className="modal-body">
                          <Row>
                            <Col lg={12}>
                              <label htmlFor="floatingDepartInput">Type</label>
                              <div className="form-floating mb-3">
                                <select
                                  className="form-select"
                                  value={selectedType}
                                  onChange={e => {
                                    handleTypeChange(e)
                                  }}
                                  disabled={RStatus == "Open" ? false : true}
                                >
                                  <option value=" ">Select</option>
                                  <option value="G/L Account">
                                    G/L Account
                                  </option>
                                  <option value="Item">Item</option>
                                  <option value="Fixed Asset">
                                    Fixed Asset
                                  </option>
                                </select>
                              </div>
                            </Col>

                            {(selectedType == "G/L Account" ||
                              selectedType == "Item" ||
                              selectedType == "Fixed Asset") && (
                              <Col lg={12}>
                                <label htmlFor="floatingSelectGrid">No</label>
                                <div className="form-floating mb-3">
                                  <Select
                                    options={noo}
                                    value={noo.find(
                                      option => option.value === selectedNo
                                    )}
                                    onChange={handleNoChange}
                                  />
                                </div>
                              </Col>
                            )}

                            <Col lg={12} className="mb-3">
                              <label htmlFor="floatingSelectGrid">
                                Workplan Entry No
                              </label>
                              <select
                                className="form-select"
                                value={workPlanEntryNo}
                                onChange={e =>
                                  setWorkPlanEntryNo(e.target.value)
                                }
                                disabled={RStatus == "Open" ? false : true}
                              >
                                <option value="">Select</option>
                                {workPlanEntry.map((l, k) => (
                                  <option key={k} value={l.entryNo}>
                                    {l.entryNo}
                                  </option>
                                ))}
                              </select>
                            </Col>

                            <Col lg={12}>
                              <label htmlFor="floatingSelectGrid">
                                Description 2
                              </label>
                              <div className="form-floating mb-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  value={description2}
                                  onChange={e =>
                                    setDescription2(e.target.value)
                                  }
                                  disabled={RStatus == "Open" ? false : true}
                                />
                              </div>
                            </Col>

                            <Col lg={6}>
                              <label htmlFor="floatingSelectGrid">
                                Quantity
                              </label>
                              <div className="form-floating mb-3">
                                <input
                                  type="number"
                                  className="form-control"
                                  value={quantity}
                                  onChange={e => {
                                    setQuantity(e.target.value)
                                  }}
                                  disabled={RStatus == "Open" ? false : true}
                                />
                              </div>
                            </Col>
                            <Col lg={6}>
                              <label htmlFor="floatingSelectGrid">
                                Unit Cost
                              </label>
                              <div className="form-floating mb-3">
                                <input
                                  type="number"
                                  className="form-control"
                                  value={directUnitCost}
                                  onChange={e => {
                                    setDirectUnitCost(e.target.value)
                                  }}
                                  disabled={RStatus == "Open" ? false : true}
                                />
                              </div>
                            </Col>
                          </Row>
                        </div>

                        <div className="modal-footer justify-content-center">
                          {isEdit &&
                            (isloading ? (
                              <button
                                type="button"
                                className="btn btn-secondary"
                                disabled={true}
                              >
                                Please wait...
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="btn btn-info"
                                onClick={() => tog_PlanningSpecifications()}
                              >
                                <i
                                  className="mdi mdi-pencil"
                                  id="edittooltip"
                                />{" "}
                                Planning/Specifications...
                              </button>
                            ))}
                          {RStatus == "Open" &&
                            isEdit &&
                            (isloading ? (
                              <button
                                type="button"
                                className="btn btn-secondary"
                                disabled={true}
                              >
                                Please wait...
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => handleUpdateLine2()}
                              >
                                <i
                                  className="mdi mdi-pencil"
                                  id="edittooltip"
                                />{" "}
                                Update line details...
                              </button>
                            ))}
                          {!isEdit &&
                            (isloading ? (
                              <button
                                type="button"
                                className="btn btn-secondary"
                                disabled={true}
                              >
                                Please wait...
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="btn btn-info"
                                onClick={() => handleAddLine2()}
                              >
                                Planning/Specifications...
                              </button>
                            ))}
                          {!isEdit &&
                            (isloading ? (
                              <button
                                type="button"
                                className="btn btn-secondary"
                                disabled={true}
                              >
                                Please wait...
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="btn btn-success"
                                onClick={() => handleAddLine2()}
                              >
                                Save line details...
                              </button>
                            ))}
                          {RStatus == "Open" &&
                            isEdit &&
                            (isloading ? (
                              <button
                                type="button"
                                className="btn btn-secondary"
                                disabled={true}
                              >
                                Please wait...
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="btn btn-danger"
                                onClick={() => handleDeleteLine2()}
                              >
                                <i
                                  className="mdi mdi-delete"
                                  id="deletetooltip"
                                />{" "}
                                Delete line...
                              </button>
                            ))}
                        </div>
                      </Modal>

                      <Modal
                        isOpen={modal_attachments}
                        toggle={() => {
                          tog_attachments()
                        }}
                        size="l"
                        centered
                        backdrop={"static"}
                      >
                        <div className="modal-header">
                          <h5
                            className="modal-title mt-0"
                            id="myModalLabel"
                          >{`Files`}</h5>
                          <button
                            type="button"
                            onClick={() => {
                              setmodal_attachments(false)
                            }}
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div className="modal-body">
                          <Row>
                            <Col xl={12}>
                              <div className="mb-3">
                                <label htmlFor="floatingnameInput">
                                  Attach Files
                                </label>
                                <input
                                  type="file"
                                  multiple
                                  className="form-control"
                                  onChange={e => handleSelectedFiles(e)}
                                />
                              </div>
                            </Col>
                          </Row>
                        </div>
                        <div className="modal-footer">
                          <button
                            onClick={() => {
                              tog_attachments()
                            }}
                            className="btn btn-danger"
                            data-dismiss="modal"
                          >
                            Cancel
                          </button>
                          <button
                            className="btn btn-success"
                            onClick={handleSaveFiles}
                          >
                            Add file(s)...
                          </button>
                        </div>
                      </Modal>

                      <Modal
                        isOpen={modal_PlanningSpecifications}
                        toggle={() => {
                          tog_PlanningSpecifications()
                        }}
                        size="xl"
                        centered
                        backdrop={"static"}
                      >
                        <div className="modal-header">
                          <h5 className="modal-title mt-0" id="myModalLabel">
                            {isEdit ? `Add/Update/Delete ` : `Add `}Planning
                            Specification Line
                          </h5>
                          <button
                            type="button"
                            onClick={() => {
                              setmodal_PlanningSpecifications(false)
                            }}
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div className="modal-body">
                          <Row>
                            <Col
                              sm={12}
                              onClick={() => {
                                setAddDetails(!addDetails)
                              }}
                            >
                              <a href="#">
                                <h5 className="text-primary">
                                  {editLine ? `Edit details` : `+ Add details`}
                                </h5>
                              </a>
                              <hr />
                            </Col>
                            {RStatus == "Open" && addDetails && (
                              <>
                                <Col lg={6}>
                                  <div className="mb-3">
                                    <label>Workplan No</label>
                                    <select
                                      className="form-select"
                                      value={workplanno}
                                      onChange={e =>
                                        setWorkPlanNo(e.target.value)
                                      }
                                      disabled={true}
                                    >
                                      <option value="">Select</option>
                                      {workplans.map((l, k) => (
                                        <option key={k} value={l.no}>
                                          {l.no}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </Col>
                                <Col lg={6}>
                                  <div className="mb-3">
                                    <label>Workplan Entry No</label>
                                    <select
                                      className="form-select"
                                      value={workPlanEntryNo}
                                      onChange={e =>
                                        setWorkPlanEntryNo(e.target.value)
                                      }
                                      disabled={true}
                                    >
                                      <option value="">Select</option>
                                      {workPlanEntry.map((l, k) => (
                                        <option key={k} value={l.entryNo}>
                                          {l.entryNo}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </Col>
                                <Col lg={12}>
                                  <label htmlFor="floatingSelectGrid">
                                    Specification
                                  </label>
                                  <div className="form-floating mb-3">
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={specification}
                                      onChange={e =>
                                        setSpecification(e.target.value)
                                      }
                                    />
                                  </div>
                                </Col>
                                <Col lg={12}>
                                  <label htmlFor="floatingSelectGrid">
                                    Planned Date
                                  </label>
                                  <div className="mb-3">
                                    <Flatpickr
                                      className="form-control"
                                      placeholder="dd M,yyyy"
                                      options={{
                                        altInput: true,
                                        altFormat: "F j, Y",
                                        dateFormat: "Y-m-d",
                                      }}
                                      value={plannedDate}
                                      onChange={e => {
                                        setPlannedDate(formatDate(e))
                                      }}
                                    />
                                  </div>
                                </Col>

                                <Col lg={6}>
                                  <label htmlFor="floatingDepartInput">
                                    Unit of Measure
                                  </label>
                                  <div className="form-floating mb-3">
                                    <select
                                      className="form-select"
                                      value={uom}
                                      onChange={e => {
                                        setUOM(e.target.value)
                                      }}
                                    >
                                      <option value="">Select</option>
                                      {unitOfMeasure.map((l, k) => (
                                        <option key={k} value={l.code}>
                                          {l.code}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </Col>

                                <Col lg={6}>
                                  <label htmlFor="floatingDepartInput">
                                    Category
                                  </label>
                                  <div className="form-floating mb-3">
                                    <select
                                      className="form-select"
                                      value={category}
                                      onChange={e => {
                                        setCategory(e.target.value)
                                      }}
                                    >
                                      <option value=" ">Select</option>
                                      <option value="Recurring">
                                        Recurring
                                      </option>
                                      <option value="Non-Recurring">
                                        Non-Recurring
                                      </option>
                                    </select>
                                  </div>
                                </Col>

                                <Col lg={6}>
                                  <label htmlFor="floatingDepartInput">
                                    Procurement Type
                                  </label>
                                  <div className="form-floating mb-3">
                                    <select
                                      className="form-select"
                                      value={procurementtype}
                                      onChange={e => {
                                        setProcurementType(e.target.value)
                                      }}
                                    >
                                      <option value=" ">Select</option>
                                      <option value="Services">Services</option>
                                      <option value="Supplies">Supplies</option>
                                      <option value="Works">Works</option>
                                    </select>
                                  </div>
                                </Col>

                                <Col lg={6}>
                                  <label htmlFor="floatingDepartInput">
                                    Procurement Method
                                  </label>
                                  <div className="form-floating mb-3">
                                    <select
                                      className="form-select"
                                      value={procurementmethod}
                                      onChange={e => {
                                        setProcurementMethod(e.target.value)
                                      }}
                                    >
                                      <option value=" ">Select</option>
                                      <option value="RFQ">RFQ</option>
                                      <option value="Invitation For Bids">
                                        Invitation for Bids
                                      </option>
                                      <option value="Direct Procurement">
                                        Direct Procurement
                                      </option>
                                    </select>
                                  </div>
                                </Col>

                                <Row className="justify-content-center">
                                  <Col md={6} className="mb-4 mt-3">
                                    <div className="d-grid">
                                      {isloading ? (
                                        <Button
                                          color="secondary"
                                          type="button"
                                          className="btn-rounded"
                                        >
                                          Please wait...
                                        </Button>
                                      ) : editLine ? (
                                        <Button
                                          color="primary"
                                          type="button"
                                          className="btn-rounded"
                                          onClick={
                                            handleUpdateManagementActivities
                                          }
                                        >
                                          Update Specification Line ...
                                        </Button>
                                      ) : (
                                        <Button
                                          color="primary"
                                          type="button"
                                          className="btn-rounded"
                                          onClick={handleAddManagement}
                                        >
                                          Save specification line ...
                                        </Button>
                                      )}
                                    </div>
                                  </Col>

                                  {editLine && (
                                    <>
                                      <Col md={6} className="mb-4 mt-3">
                                        <div className="d-grid">
                                          <Button
                                            color="warning"
                                            type="button"
                                            className="btn-rounded"
                                            onClick={handleAddManagement}
                                          >
                                            Add planning specification line
                                          </Button>
                                        </div>
                                      </Col>
                                    </>
                                  )}
                                </Row>
                              </>
                            )}
                            <Col sm={12}>
                              <h5 className="text-primary">- View details</h5>
                              <hr />
                            </Col>
                            <Col lg={12}>
                              {managementActivities.length > 0 ? (
                                <div className="table-responsive">
                                  <Table className="table table-striped table-wrap table-sm mb-4">
                                    <thead>
                                      <tr>
                                        <th>Work plan No.</th>
                                        <th>Work Plan Entry No.</th>
                                        <th>Specification</th>
                                        <th
                                          style={{
                                            verticalAlign: "middle",
                                            textAlign: "center",
                                          }}
                                        >
                                          Planned Date
                                        </th>
                                        <th
                                          style={{
                                            verticalAlign: "middle",
                                            textAlign: "center",
                                          }}
                                        >
                                          Unit of Measure
                                        </th>
                                        <th
                                          style={{
                                            verticalAlign: "middle",
                                            textAlign: "center",
                                          }}
                                        >
                                          Category
                                        </th>
                                        <th
                                          style={{
                                            verticalAlign: "middle",
                                            textAlign: "center",
                                          }}
                                        >
                                          Procurement Type
                                        </th>
                                        <th
                                          style={{
                                            verticalAlign: "middle",
                                            textAlign: "center",
                                          }}
                                        >
                                          Procurement Method
                                        </th>
                                        <th
                                          style={{
                                            verticalAlign: "middle",
                                            textAlign: "center",
                                          }}
                                        ></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {managementActivities.map((a, k) => (
                                        <tr key={k}>
                                          <td>{a.workplanNo}</td>
                                          <td>{a.workplanEntry}</td>
                                          <td>{a.specification}</td>
                                          <td
                                            style={{
                                              verticalAlign: "middle",
                                              textAlign: "center",
                                            }}
                                          >
                                            {a.plannedDate}
                                          </td>
                                          <td
                                            style={{
                                              verticalAlign: "middle",
                                              textAlign: "center",
                                            }}
                                          >
                                            {a.unitmeasure}
                                          </td>
                                          <td
                                            style={{
                                              verticalAlign: "middle",
                                              textAlign: "center",
                                            }}
                                          >
                                            {a.category}
                                          </td>
                                          <td
                                            style={{
                                              verticalAlign: "middle",
                                              textAlign: "center",
                                            }}
                                          >
                                            {a.procurementType}
                                          </td>
                                          <td
                                            style={{
                                              verticalAlign: "middle",
                                              textAlign: "center",
                                            }}
                                          >
                                            {a.procurementMethod}
                                          </td>
                                          <td
                                            style={{
                                              verticalAlign: "middle",
                                              textAlign: "center",
                                            }}
                                          >
                                            {" "}
                                            <>
                                              {RStatus == "Open" && (
                                                <div className="d-flex gap-3">
                                                  <Link
                                                    to="#"
                                                    className="text-success"
                                                    onClick={() =>
                                                      handleEditManagement(k)
                                                    }
                                                  >
                                                    <i
                                                      className="mdi mdi-pencil font-size-18"
                                                      id="edittooltip"
                                                    />
                                                    <UncontrolledTooltip
                                                      placement="top"
                                                      target="edittooltip"
                                                    >
                                                      Edit
                                                    </UncontrolledTooltip>
                                                  </Link>
                                                  <Link
                                                    to="#"
                                                    className="text-danger"
                                                    onClick={() =>
                                                      handleDeleteManagement(k)
                                                    }
                                                  >
                                                    <i
                                                      className="mdi mdi-delete font-size-18"
                                                      id="deletetooltip"
                                                    />
                                                    <UncontrolledTooltip
                                                      placement="top"
                                                      target="deletetooltip"
                                                    >
                                                      Delete
                                                    </UncontrolledTooltip>
                                                  </Link>
                                                </div>
                                              )}
                                            </>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </Table>
                                </div>
                              ) : (
                                <div className="text-center">
                                  <div className="mb-4">
                                    <i className="mdi mdi-check-circle-outline text-success display-4" />
                                  </div>
                                  <div>
                                    <h5>No details found</h5>
                                    <p className="text-muted"></p>
                                  </div>
                                </div>
                              )}
                            </Col>
                          </Row>
                        </div>
                      </Modal>

                      <Modal
                        isOpen={modal_comments}
                        toggle={() => {
                          tog_comments()
                        }}
                        centered
                        size="xl"
                      >
                        <div className="modal-header">
                          <h5 className="modal-title mt-0" id="myModalLabel">
                            Rejection Comments
                          </h5>
                          <button
                            type="button"
                            onClick={() => {
                              setmodal_comments(false)
                            }}
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div className="modal-body">
                          <Row>
                            <Col lg={12}>
                              {approvalCommentLines.length > 0 ? (
                                <div className="table-responsive">
                                  <Table className="table table-sm m-0">
                                    <thead>
                                      <tr>
                                        <th>Document No.</th>
                                        <th>Comment</th>
                                        <th>Rejected by</th>
                                        <th>Rejection Date/Time</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {approvalCommentLines.map((a, k) => (
                                        <tr key={k}>
                                          <td>{a.document_No}</td>
                                          <td>{a.Comment}</td>
                                          <td>{a.rejected_By}</td>
                                          <td>{a.rejected_Date_Time}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </Table>
                                </div>
                              ) : (
                                <div className="text-center">
                                  <div className="mb-4">
                                    <i className="bx bx-book-content text-warning display-4" />
                                  </div>
                                  <div>
                                    <h5>No rejection comments found</h5>
                                    <p className="text-muted"></p>
                                  </div>
                                </div>
                              )}
                            </Col>
                          </Row>
                        </div>
                      </Modal>
                    </CardBody>
                  </Card>
                </Col>
                <Col></Col>
              </Row>
            ) : (
              <Row className="d-flex justify-content-center">
                <Col lg={8}>
                  <Card outline color="success" className="border">
                    <CardBody>
                      <CardTitle className="mb-4 text-white"></CardTitle>
                      <CardText></CardText>
                      <div className="text-center">
                        <div className="mb-4">
                          <i className="mdi mdi-check-circle-outline text-success display-4" />
                        </div>
                        <div>
                          <h5>Saved</h5>
                          <p className="text-muted">
                            Requisition <strong>{rNo}</strong> Saved!
                          </p>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            )}
          </div>
        </Container>
      </div>
    </LoadingOverlay>
  )
}

export default PurchaseRequisitionDetails
